export default __webpack_public_path__ + "static/media/image-61.6102e5aa.png";